import invoke from 'lodash/invoke';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import request from '../request';
import Icon from './icons';
import { SUPPORTED_LANGUAGES } from '../constants';

const checkIcon = Icon({ type: 'check', color: '#', size: 18 });
const closeIcon = Icon({
  type: 'keyboard_arrow_right',
  color: '#0e68f9',
  size: 18,
});
class LanguageSelectModal {
  constructor(container, callback) {
    this.hasAttachedEvents = false;
    this.getText = Pollfish.ui.getText;

    this.onSelect = callback;

    this.template = `
      <div class="modal modal--fullscreen">
        <div class="modal-content">
          <div class="modal-header container">
            <button class="js-modal-cancel">
              <span style="transform: rotate(180deg)">${closeIcon}</span>
              <span style="margin-left: 5px; margin-top: -1px;">${this.getText(
                'cancel',
              )}</span>
            </button>
            <h2 class="js-modal-header text-align-center flex-1 margin-reset">${this.getText(
              'language',
            )}</h2>
            <button class="js-modal-confirm" disabled>
              ${checkIcon}
              <span style="margin-left: 5px; margin-top: 1px;">${this.getText(
                'done',
              )}</span>
            </button>
          </div>
          <div class="modal-body container">
          </div>
        </div>
      </div>
    `;

    this.container = $(this.template);
    container.append(this.container);
  }

  show() {
    this.container.addClass('open');
    this.container.find('.js-modal-confirm').attr('disabled', true);
    this.renderListItem();
    this.attachEvents();
  }

  attachEvents() {
    // attachEvents would get called more than once
    if (this.hasAttachedEvents) {
      return;
    }
    this.hasAttachedEvents = true;
    const { container } = this;
    container.on('tap', '.answer', (e) => {
      e.preventDefault();
      let answerEl = $(e.target);
      if (!answerEl.hasClass('.answer')) {
        answerEl = answerEl.closest('div.answer');
      }
      $('.answerClick').removeClass('answerClick');
      answerEl.toggleClass('answerClick');
      container.find('.js-modal-confirm').removeAttr('disabled');
    });

    container.find('.js-modal-cancel').on('tap', () => {
      this.close();
    });

    container.find('.js-modal-confirm').on('tap', () => {
      const selectedAnswer = container.find('.answerClick');
      if (!selectedAnswer.length) {
        Pollfish.ui.prompt(this.getText('warnings.single'));
        return;
      }
      const langId = selectedAnswer.data('value');
      if (!langId) {
        const error = new Error('SelectedLanguage to fetch is missing');
        this.handleError(error, selectedAnswer, container);
        return;
      }
      this.fetchTranslations(langId);
    });
  }

  fetchTranslations(selectedLanguage) {
    const body = this.container.find('.modal-body');
    const surveyId = Pollfish.survey && Pollfish.survey.getSurveyId();
    let url = `/v2/device/translations?lang=${selectedLanguage}`;
    const surveyLang = get(Pollfish, 'helper.json.lang', undefined);
    if (surveyId) {
      url += `&surveyId=${surveyId}`;
    }
    if (surveyLang) {
      url += `&surveyLang=${surveyLang}`;
    }
    body.html(Pollfish.ui.getSpinner());
    request({ url })
      .then((payload = {}) => {
        const {
          translations,
          tag_questions: tagQuestions,
          sanity_questions: sanityQuestions,
          feedback_questions: feedbackQuestions,
          profiling_questions: profilingQuestions,
          tag_survey: tagSurvey,
        } = payload.data;

        const localTagSurvey = get(Pollfish, 'helper.json.tag_survey');
        let updatedTagQuestions = tagQuestions;
        let updatedSanityQuestions = sanityQuestions;
        let updatedProfilingQuestions = profilingQuestions;
        let updatedFeedbackQuestions = feedbackQuestions;

        // If it is offerwall means that server will respond with a tag survey object
        // and the local tag survey should be updated since we initialize the demographic
        // survey based on tag survey data on offerwall
        if (
          Pollfish.helper.isOfferwall() &&
          tagSurvey &&
          localTagSurvey &&
          !isEmpty(localTagSurvey)
        ) {
          updatedTagQuestions = tagSurvey.tag_questions;
          updatedSanityQuestions = tagSurvey.sanity_questions;
          updatedProfilingQuestions = tagSurvey.profiling_questions;
          updatedFeedbackQuestions = tagSurvey.feedback_questions;

          Pollfish.helper.json.tag_survey = tagSurvey;
        }

        Pollfish.helper.addTranslation({
          lang: selectedLanguage,
          texts: translations,
          feedbackQuestions: updatedFeedbackQuestions,
        });
        Pollfish.helper.changeLanguage(selectedLanguage);
        Pollfish.helper.json.user_lang = selectedLanguage;
        // there should not be previousLang since user selected a new language
        Pollfish.ui.previousLang = null;

        // in case a survey hasn't started yet
        Pollfish.helper.json.tag_questions = updatedTagQuestions;
        Pollfish.helper.json.sanity_questions = updatedSanityQuestions;
        Pollfish.helper.json.profiling_questions = updatedProfilingQuestions;

        // in case a survey is already in progress
        Pollfish.demographics.setQuestions(updatedTagQuestions);
        Pollfish.sanity.setQuestions(updatedSanityQuestions);
        Pollfish.profiling.setQuestions(updatedProfilingQuestions);

        this.close();
        invoke(this, 'onSelect');
      })
      .catch((e) => this.handleError(e));
  }

  handleError(e, selectedAnswer, container) {
    if (e) {
      Raven.captureException(e, {
        extra: {
          selectedAnswer,
          elementData: selectedAnswer && selectedAnswer.data(),
          modalContainer: container && container.html(),
          survey_id: Pollfish.helper.json.s_id,
        },
      });
    }
    const body = this.container.find('.modal-body');
    const currentTemplate = body.html();
    this.close();
    this.container.html(currentTemplate);
    Pollfish.ui.promptError('Something went wrong');
  }

  detachEvents() {
    this.container.find('.js-modal-cancel').off('tap');
    this.container.find('.js-modal-confirm').off('tap');
  }

  close() {
    $('.answerClick').removeClass('answerClick');
    const { container } = this;
    container.removeClass('open');
    this.detachEvents();

    container.empty();
  }

  renderListItem() {
    const template = SUPPORTED_LANGUAGES.map(
      (lang) =>
        `<div class="answer answer--single-choice" data-value="${lang.key}">${lang.value}</div>`,
    );

    this.container.find('.modal-body').html(template);
  }
}

export default LanguageSelectModal;
